export const trackingEvents = {
  PAGE: {
    VIEWED: 'worker_detail.page.viewed',
  },
  CREATE_WEEKLY_HOLIDAY_PAY_REQUEST: {
    CLICKED: 'worker_detail.create_weekly_holiday_pay_request.clicked',
  },
}
